import { ClassicPreset , GetSchemes, NodeEditor } from 'rete';
import { DataflowEngine, DataflowNode } from "rete-engine";
import { DataSourceControl } from '../controls/dataSourceControl';
import { IapComponent } from '../../../../../component/domain/iapComponent';
import { AreaPlugin } from 'rete-area-plugin';
import { AreaExtra, Schemes } from '../rete/helperRete';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';

export class DataSourceNode extends ClassicPreset.Node<  
  {ejecutar: ClassicPreset.Socket},
  {ejecutar: ClassicPreset.Socket, value: ClassicPreset.Socket},  
  { value: DataSourceControl }  
> {
  height = 180;
  width = 180;
  private value:Number;
  private componentId : Number;
  private area :AreaPlugin<Schemes, AreaExtra>;
  private dsControlId:'';
  
  private updateNode: any;

  constructor(area:AreaPlugin<Schemes, AreaExtra>, socket:ClassicPreset.Socket,componentId:Number,selectedValue:Number, dataSources: IapComponentDataSource[], updateNode: any= undefined) {
    super("Origen de datos");
    this.value = selectedValue;
    this.componentId = componentId;
    this.area = area;
    this.updateNode = updateNode;
  
    //const dsControl = new DataSourceControl();

    const dsControl =  new DataSourceControl(componentId,selectedValue,dataSources,
        this.updateData
        );

    
    this.dsControlId = (dsControl as any).id;
   

    this.addInput("ejecutar", new ClassicPreset.Input(socket, "Ejecutar", true));
    this.addControl(
      "value",
     dsControl
      
      //new ClassicPreset.InputControl("text", { initial })
    );
   
    this.addOutput("ejecutar", new ClassicPreset.Output(socket, "Ejecutar"));


    //area.update("control",dsControl.id)
    this.addOutput("value", new ClassicPreset.Output(socket, "Valor"));

    
    
  }

   updateData =  (evt:any) =>{
    this.value=evt    
    this.controls['value'].value=evt;
    
    this.area.update("control",this.dsControlId)

    if (this.updateNode){
      this.updateNode(this.id,'value',this.value,true, false)
    }    
  }
  async execute(input: "entrada", forward: (output: "salida") => void) {
   
    //MessageService.showToast(MessageType.Info, '', (inputs.message && inputs.message[0]) || "");
    //this.log((inputs.message && inputs.message[0]) || "");

    forward("salida");
  }


  data(): { value: Number } {
    return {
      value: this.controls.value.value  ?? -1
    };
  }
}